import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { ModalButtonSave } from '../../constant';
import { FormMicEstatus } from './FormMicEstatus';
import { Dialog } from 'primereact/dialog';

export const ModalMicEstatus = (props) => {
    const {
        modal,
        modalTitle,
        closeDialog,
        method,
        loading,
        status,
        handleInputChange,
        validaciones,
        saveCreate
    } = props;

    return (
        <Dialog 
            header={modalTitle}
            visible={modal}
            onHide={closeDialog}
            closable={true}
            modal
            blockScroll
            className='medium-dialog'
        >

            {
                method === "create" && (
                    <FormMicEstatus
                        button={ModalButtonSave}
                        {...{ closeDialog, loading, handleInputChange, methodAction: saveCreate }}
                    />
                )
            }
        </Dialog>
    );
};
